import { z } from "zod";
import { type FieldDescriptor } from "./types.js";

// A single boolean (docs/01-PRODUCT-SPEC.md §3.2) — not a multi-select.
const configSchema = z.object({
  checkboxLabel: z.string().max(500).default(""),
});

export const checkboxField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "checkbox",
  label: "Checkbox",
  category: "choice",
  icon: "SquareCheck",
  configSchema,
  valueSchema: (_config, isRequired) =>
    isRequired
      ? z.literal(true, { errorMap: () => ({ message: "This must be ticked to continue" }) })
      : z.boolean().optional().nullable(),
  defaultConfig: { checkboxLabel: "" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: {},
};
